export default function CheckCircleFilled() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      viewBox="0 0 21 21"
    >
      <g id="check-circle-filled">
        <path
          id="Vector"
          fill="#52C41A"
          d="M10.714 1.75a8.75 8.75 0 1 0 .001 17.501 8.75 8.75 0 0 0 0-17.5m3.78 5.893-4.114 5.703a.622.622 0 0 1-1.01 0L6.936 9.97a.157.157 0 0 1 .127-.248h.916c.2 0 .389.095.506.26l1.39 1.93 3.07-4.259a.63.63 0 0 1 .507-.26h.916c.127 0 .2.145.127.249"
        ></path>
      </g>
    </svg>
  );
}
